// extracted by mini-css-extract-plugin
export default {"spinner":"Button_spinner__oZETC","button-rotation":"Button_button-rotation__wxjFG"};